import { Root } from "mdast";
import { Plugin } from "unified";
import {
  createCustomElement,
  createTextVisitor,
  isValidTextNodeContext,
  processTextWithRegex,
  ReplacementResult,
} from "../react-markdown-registry/utils";

/**
 * Remark plugin that converts [1] citations to paper_cite nodes
 * This is the first stage of the citation processing pipeline
 *
 * Converts: "[1]" -> paper_cite node with paperIndex=0 (0-based indexing)
 */
export const remarkLegacyNumberCitations: Plugin<[], Root> = () => {
  let globalCitationCounter = 0;

  return (tree) => {
    const visitText = createTextVisitor();

    visitText(tree, (node, index, parent) => {
      if (!isValidTextNodeContext(node, index, parent)) return;
      if ((node as any).__remarkCitationProcessed) return;

      // Only match individual citations, not groups
      const citationRegex = /\[(\d+)\]/g;

      return processTextWithRegex(
        node,
        index,
        parent,
        citationRegex,
        (match, matchIndex): ReplacementResult => {
          const [, numberStr] = match;
          const paperIndex = parseInt(numberStr, 10) - 1; // Convert 1-based to 0-based

          // Create paper_cite node with basic metadata
          // Context extraction will be handled by remarkCitationContextExtraction plugin
          const paperCiteNode = createCustomElement("paper_cite", {
            paperIndex,
            stableKey: `individual-cite-${++globalCitationCounter}`,
          });

          // Mark as processed to avoid double processing
          (paperCiteNode as any).__remarkCitationProcessed = true;

          return {
            node: paperCiteNode,
          };
        }
      );
    });
  };
};
